let domain = document.domain;

export function yandex(target) {
	let config = shopOrdercallConfig.yandex;
	let _domain = domain;
	target = target || 'send';

	if (!config[_domain]) {
		_domain = 'general';
		if (!config[_domain]) {
			return false;
		}
	}

	let ya_data = {
		'open': (config[_domain].open || ''),
		'send': (config[_domain].send || ''),
		'error': (config[_domain].error || ''),
		'smart_button_click': (config[_domain].smart_button_click || ''),
		'smart_button_send': (config[_domain].smart_button_send || '')
	};

	let yaCounter = window['yaCounter' + (config[_domain].counter || '')];
	if (ya_data[target] && (typeof yaCounter == 'object')) {
		yaCounter.reachGoal(ya_data[target]);

		return true;
	}

	return false;
}

export function google(target) {
	let config = shopOrdercallConfig.google;
	let _domain = domain;
	target = target || 'send';

	if (!config[_domain]) {
		_domain = 'general';
		if (!config[_domain]) {
			return false;
		}
	}

	let ga_data = {
		'open': {
			'category': (config[_domain].open.category || ''),
			'action': (config[_domain].open.action || '')
		},
		'send': {
			'category': (config[_domain].send.category || ''),
			'action': (config[_domain].send.action || '')
		},
		'error': {
			'category': (config[_domain].error.category || ''),
			'action': (config[_domain].error.action || '')
		},
		'smart_button_click': {
			'category': (config[_domain].smart_button_click.category || ''),
			'action': (config[_domain].smart_button_click.action || '')
		},
		'smart_button_send': {
			'category': (config[_domain].smart_button_send.category || ''),
			'action': (config[_domain].smart_button_send.action || '')
		}
	};

	if (ga_data[target].category && (typeof ga == 'function')) {
		ga('send', 'event', ga_data[target].category, ga_data[target].action);

		return true;
	}

	return false;
}

export default function (target) {
	target = target || 'send';
	let result = yandex(target);
	result = google(target) && result;

	return result;
}


// WEBPACK FOOTER //
// ./src/webpack/frontend/ordercall/target.js